import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';

interface TitleProps {
  title: string | JSX.Element;
  isActive?: boolean;
  className?: string;
}

const StyledTitle = styled.h4`
  color: ${({ theme }) => theme.components.optionTitle.titleColor.inactive};
  font-weight: 400;
  font-size: ${({ theme }) => theme.components.optionTitle.fontSize};
  font-weight: ${({ theme }) => theme.components.optionTitle.fontWeight?.inactive};
  line-height: ${({ theme }) => theme.components.optionTitle.lineHeight};
  text-transform: capitalize;

  &.active {
    color: ${({ theme }) => theme.components.optionTitle.titleColor.active};
    font-weight: ${({ theme }) => theme.components.optionTitle.fontWeight?.active};
    font-weight: 600;
  }
`;

const OptionTitle: React.FC<TitleProps> = ({ title, isActive = false, className }) => (
  <StyledTitle className={cx(className, { active: isActive })}>{title}</StyledTitle>
);

export default OptionTitle;
